import React from "react";

import { connect } from "react-redux";
import styled from "styled-components";

import FormHOC from "hoc/FilltersForm";
import Checkbox from "hoc/Checkbox";
import CustomField from "components/Form/CustomField";
import InputSearch from "components/Form/InputSearch";
import { debounce } from "utils";

import { Form, Schema, SelectPicker } from "rsuite";

const { StringType } = Schema.Types;

const filtersModel = Schema.Model({
    str: StringType().maxLength(40, "The maximum is only 40 characters."),
});


const RangesFilters = ({ loading, worldzoneList, destinationList, subdestinationList, defaultValues = {}, onChange, defaultSPKey, isMobile }) => {
    const [sde_key, setSde] = React.useState(null);

    React.useEffect(() => {
        if (defaultValues.sde_key)
            setSde(defaultValues.sde_key);
    }, [defaultValues]);

    return (
        <StyledForm
                layout="inline"
                isMobile={isMobile}
                onChange={debounce(onChange, 300)}
                formDefaultValue={defaultValues}
                model={filtersModel}
            >
                <CustomField
                    name="str"
                    disabled={loading}
                    accepter={InputSearch}
                    errorPlacement="topRight"
                    placeholder="Range name/Numbers search"
                    style={{ width: isMobile ? "100%" : 220 }}
                />
                <CustomField
                    disabled={loading}
                    accepter={SelectPicker}
                    labelKey="name"
                    valueKey="wz_key"
                    data={worldzoneList}
                    placeholder="Worldzone"
                    name="wz_key"
                    style={isMobile ? { width: "100%" } : {}}
                    menuStyle={{ width: 280 }}
                />
                <CustomField
                    disabled={loading}
                    accepter={SelectPicker}
                    data={destinationList}
                    labelKey="name"
                    valueKey="de_key"
                    placeholder="Destination"
                    name="de_key"
                    style={isMobile ? { width: "100%" } : {}}
                    menuStyle={{ width: 280 }}
                />
                <CustomField
                    disabled={loading}
                    accepter={SelectPicker}
                    data={subdestinationList}
                    labelKey="name"
                    valueKey="sde_key"
                    onChange={(sde_key) => setSde(sde_key)}
                    value={sde_key}
                    placeholder="Subdestination"
                    name="sde_key"
                    classPrefix="allocated"
                    style={isMobile ? { width: "100%" } : {}}
                    menuStyle={{ width: 320 }}
                />
                <Checkbox name="only_with_unallocated_numbers" defaultChecked disabled={loading}>Show only available ranges</Checkbox>
                <Checkbox name="only_without_test_numbers" disabled={loading}>Show private ranges</Checkbox>
                <Checkbox name="only_with_incorporated_numbers" disabled={loading}>Show only global access numbers ranges</Checkbox>
            </StyledForm>
    );
};

const mapStateToProps = ({ references }) => ({
    defaultSPKey: references.defaultSPKey
});

export default connect(mapStateToProps)(FormHOC(RangesFilters, filtersModel, 300));

const StyledForm = styled(Form)`
    margin-bottom: ${props => props.isMobile ? 0 : -25}px;

    ${props => props.isMobile && `
        && {
            display: grid;
            grid-template-columns: minmax(0, 1fr);
            row-gap: 8px;
            width: 100%;
        }

        && > * {
            margin-right: 0;
        }

        && > .rs-form-group {
            width: 100%;
            margin-bottom: 0;
        }

        && .rs-form-control-wrapper,
        && .rs-input-group,
        && .rs-picker-default,
        && .rs-picker-toggle-wrapper,
        && .rs-picker-toggle {
            width: 100% !important;
        }

        && .rs-checkbox {
            margin-left: 0;
        }
    `}
`;
